import { IGetOverTimeListRequest } from "../types"
import { IEmployeeDetailsRequestType, IGetCurrentOverTimeRequestType } from "./type"
const employeeBaseUrl = '/employee/overtime'
export const EmployeeOvertimeEndpointConst = {
    overTimeList: `${employeeBaseUrl}/list`,
    AddUpdateOverTime: `${employeeBaseUrl}`,
    AddOverTimeStatus: `${employeeBaseUrl}/status`
}

export const deleteOverTime = (overTimeId: number) => {
    return `${employeeBaseUrl}/${overTimeId}`
}
export const getCurrentOverTime = (params: IGetCurrentOverTimeRequestType) => {
    return `${employeeBaseUrl}/${params.overTimeId}`
}
export const getEmployeeInfoByCodeUrl = (params: IEmployeeDetailsRequestType) => {
    return `employee/${params.employeeCode}/contract/employee-information`
}
export const getOverTimeListByCode = (params: IGetOverTimeListRequest) => {
    return `${employeeBaseUrl}/${params.employeeCode}/list`
}
